module.exports = __webpack_public_path__ + "static/gallery1-605e207d11ebbe0976cb1584bfaa9da9.png";